import { render, staticRenderFns } from "./DialogNode.vue?vue&type=template&id=506e281c&scoped=true&"
import script from "./DialogNode.vue?vue&type=script&lang=js&"
export * from "./DialogNode.vue?vue&type=script&lang=js&"
import style0 from "./DialogNode.vue?vue&type=style&index=0&id=506e281c&prod&scoped=true&lang=scss&"
import style1 from "./DialogNode.vue?vue&type=style&index=1&id=506e281c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506e281c",
  null
  
)

export default component.exports